import { BriefTimelinePopOver } from "@features/briefTimeline/BriefTimelinePopOver";
import {
  IBrandCostRequest,
  IBriefInfluencerV2,
} from "@shared/lib/types/briefInfluencerV2";
import { Button } from "@shared/ui/Button";
import { Checkbox } from "@shared/ui/Checkbox";
import { InputNumber } from "@shared/ui/InputNumber";
import { Col, Flex, Form, Input, Row, Space } from "antd";
import { useEffect } from "react";
import styles from "./styles.module.scss";

export function AddCommercials({
  initialValues,
  onClose,
  handleSave,
  isLoading,
  infNotes,
  influencerPrice,
  briefInfluencer,
}: {
  briefInfluencer: IBriefInfluencerV2;
  initialValues: Partial<{
    estViews: number;
    isNonCancellable: boolean;
    cost: number;
    note: string;
  }>;
  onClose: () => void;
  handleSave: (values: Omit<IBrandCostRequest, "briefInfluencerId">) => void;
  isLoading: boolean;
  influencerPrice: number;
  infNotes: string;
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);
  const cost = Form.useWatch("cost", form);
  const view = Form.useWatch("estViews", form);

  const cpv = ((cost || 0) / (view || 1)).toFixed(2);
  const revenue = (cost || 0) - (influencerPrice || 0);
  const revenuePercentage = (
    (((cost || 0) - influencerPrice) / (cost || 1)) *
    100
  ).toFixed(2);

  return (
    <Form
      form={form}
      className={styles.commercialsForm}
      layout="vertical"
      onFinish={(values) => {
        handleSave(values);
      }}
      initialValues={{ ...initialValues }}
    >
      <Row gutter={[20, 20]}>
        <Col span={8}>
          <Form.Item
            label={
              <Space>
                <BriefTimelinePopOver
                  briefInfluencer={briefInfluencer}
                  type="brand"
                />
                Brand Price
              </Space>
            }
            name="cost"
            rules={[
              { required: true, message: "Please enter the  commercials" },
            ]}
          >
            <InputNumber placeholder="Cost" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Influencer Price" name="">
            <InputNumber
              placeholder={influencerPrice?.toString()}
              disabled
              value={influencerPrice}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Revenue">
            <Input
              disabled
              value={`${revenue.toFixed(2)} (${revenuePercentage}%)`}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="No cancellation"
        name="isNonCancellable"
        valuePropName="checked"
      >
        <Checkbox>
          The creator is non-cancellable
          <div style={{ fontWeight: 400, fontSize: 14 }}>
            (In case of advance payments or large creators)
          </div>
        </Checkbox>
      </Form.Item>

      <Flex justify="end" gap={4}>
        <Button onClick={onClose}>Back</Button>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Confirm
        </Button>
      </Flex>
    </Form>
  );
}
